export class ErrorWithAttachedObject extends Error {
  objectIdentifier: string;
  objectType: string;

  constructor(message: string, objectIdentifier: string, objectType: string) {
    super(message);
    this.objectIdentifier = objectIdentifier;
    this.objectType = objectType;
  }
}

// Convert an error object to a string
export function errorString(e: unknown): string {
  return e instanceof Error
    ? e.message
    : typeof e === "object" && e !== null
      ? JSON.stringify(e)
      : String(e);
}
